import React from 'react';

function Nauru(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124033)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H36V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_800_124033"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_800_124033)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8V12H36V8H0Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.93333 19.5796L8.19511 21.5849L8.11487 19.0544L5.38261 19.7686L6.991 17.6794L4.30833 16.8296L6.991 15.9798L5.38261 13.8907L8.11487 14.6048L8.19511 12.0743L9.93333 14.0796L11.6716 12.0743L11.7518 14.6048L14.4841 13.8907L12.8757 15.9798L15.5583 16.8296L12.8757 17.6794L14.4841 19.7686L11.7518 19.0544L11.6716 21.5849L9.93333 19.5796Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124033">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Nauru;
